import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _AssetTicketCode, _FixedAssetLinetwo, _GetMaxTicketCode, _RestartFixedAsset, _UpDepreciationParams } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectAccountantTree } from "../../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { SelectDepreciationUnits } from "./SelectDepreciationUnits";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { AuxiliaryBrandList } from "./AuxiliaryBrandList/AuxiliaryBrandList";
import { AccountantYear } from "../../../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";



export const FixedAssetLine = () => {

    const fixedAssetline = useDataBean(_FixedAssetLinetwo);
    const restart = useDataBean(_RestartFixedAsset);
    const upfixed = useDataBean(_UpDepreciationParams);
    const get = useDataBean(_GetMaxTicketCode);
    const single = Singleton.getInstance();
    const def = useDataBean(_AssetTicketCode);
    const [lista, setLista] = useState<any>([]);
    const [form, setForm] = useState<any>({
        consecutive: 1,
        newConsecutive: null
    })
    const [object, setObject] = useState<any>([]);
    const [modaldef, setModaldef] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRe, setModalRe] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalupdate, setModalupdate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalup, setModalup] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcuentas, setModalcuentas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        fixedAssetline.instance.getFixedAssetLineCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        fixedAssetline.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        fixedAssetline.deleteItemVoid(fixedAssetline.bean.IDLine).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        fixedAssetline.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const verdef = () => {
        setModaldef({ ...modaldef, "view": true });

    }
    const verreiniciar = () => {
        setModalRe({ ...modalRe, "view": true });

    }
    const verup = () => {
        setModalup({ ...modalup, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDLine', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre de Línea de Activos', property: 'Description', visible: true },
        { title: 'Cuenta de Activo Fijo (D)', property: 'FixedAssetAccountantIDStrName', visible: true },
        { title: 'Cuenta de Depreciación (C)', property: 'DepreciationAccountantIDStrName', visible: true },
        { title: 'Cuenta de Gasto (D)', property: 'ExpensiveAccountantIDStrName', visible: true },
        { title: 'Vida útil NIIF', property: 'LiveTime', visible: true },
        { title: 'Cuenta de Activo en Almacén (D)', property: 'FixedAssetStoredAccountantIDStrName', visible: true },
        { title: 'Cuenta Débito Control (D)', property: 'DebtControlAccountantIDStrName', visible: true },
        { title: 'Cuenta Crédito Control (C)', property: 'CreditControlAccountantIDStrName', visible: true },
        { title: 'Cuenta Revalorización (D)', property: 'RevaluationAccountantIDDebtStrName', visible: true },
        { title: 'Cuenta Revalorización (C)', property: 'RevaluationAccountantIDCreditStrName', visible: true },
        { title: 'Cuenta Activo Devolutivo (D)', property: 'AccountantIDReturnableStrName', visible: true },
        { title: 'Cuenta Desvalorización (D)', property: 'DevaluationAccountantIDDebtStrName', visible: true },
        { title: 'Cuenta Desvalorización (C)', property: 'DevaluationAccountantIDCreditStrName', visible: true },
        { title: 'Cuenta Activos Menor Cuantía', property: 'MinFixedAssetAccountantIDStrName', visible: true },
        { title: 'Cuenta Entrada Almacén Puente Pago', property: 'InventoryEntryCreditAccountantIDStrName', visible: true },
        { title: 'Utilizar Cuenta Puente por Pagar', property: 'UseInventoryEntryCreditAccountantIDStr', visible: true },
        { title: 'Depreciable', property: 'Depreciable', visible: true },
        { title: 'Amortizar', property: 'Amortize', visible: true },
        { title: 'Asegurado', property: 'InsurancePolicy', visible: true },
        { title: 'Cuenta (C) Venta de Activos', property: 'SelledAccountantIDStrName', visible: true },
        { title: 'Cuenta Deterioro(D)', property: 'DeteriorationAccountantIDDebtStrName', visible: true },
        { title: 'Cuenta Deterioro (C)', property: 'DeteriorationAccountantIDCreditStrName', visible: true },
        { title: 'Unidades Depreciación', property: 'DepreciationUnitsTypeName', visible: true },
        { title: 'Vida Útil Fiscal', property: 'FiscalLiveTime', visible: true },
        { title: 'Depreciación Fiscal', property: 'FiscalDepreciable', visible: true },
        { title: 'Usar Cuenta de Amortización', property: 'UseDepreciationIDForAmortization', visible: true },
        { title: 'Cuentas de Orden para Totalmente Depreciado', property: 'OrderControlForTotalDepreciation', visible: true },
        { title: 'Concepto Cuentas de Orden', property: 'IDFixedAssetOrderConcept', visible: true },
        { title: 'Usar Cuenta Servicio Siempre', property: 'UseBrandIDAlways', visible: true },
        { title: 'Validar Tiempo en Depreciación/Amortización', property: 'DoTimeRate', visible: true },
    ]

    const updateFixedAssetParams = () => {

        fixedAssetline.instance.updateFixedAssetParams(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    toast.info('Actualizado Correctamente');
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const setFixedAssetTicketCodeConsecutive = () => {

        def.instance.setFixedAssetTicketCodeConsecutive(def.bean.Consecutive).then(
            (resp: any) => {
                if (resp) {
                    getLista()
                    toast.success('Definido Correctamente');
                    setModaldef({ ...modaldef, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const restartFixedAssetConsecutivesFrom = () => {

        restart.instance.restartFixedAssetConsecutivesFrom(form.Year, form.Consecutive, form.newConsecutive).then(
            (resp: any) => {
                if (resp) {
                    getLista()
                    toast.success('Numeración Reiniciada');
                    setModalRe({ ...modalRe, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const updateFixedAssetDepreciationParams = () => {

        upfixed.instance.updateFixedAssetDepreciationParams(fixedAssetline.bean.IDLine, upfixed.bean.ApplyToAll).then(
            (resp: any) => {
                if (resp) {
                    getLista()
                    toast.success('Actualizada');
                    setModalupdate({ ...modalupdate, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const updateFixedAssetDepreciationParamstwo = () => {

        upfixed.instance.updateFixedAssetDepreciationParams(null, upfixed.bean.ApplyToAll).then(
            (resp: any) => {
                if (resp) {
                    getLista()
                    toast.success('Actualizada');
                    setModalup({ ...modalup, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const getMaxTicketCode = () => {

        get.instance.getMaxTicketCode(null).then(
            (resp: any) => {
                if (resp) {
                    getLista()
                    // toast.success('Consultado');
                    toast.success(resp);
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${fixedAssetline.bean.Name}`, "view": true }) } },
            { titulo: 'Configurar Cuentas Contables de Depreciación a nivel de Auxiliar', icono: 'ri-file-edit-fill', visible: true, evento: () => { setModalcuentas({ ...modalcuentas, "view": true }) } },
            { titulo: 'Actualizar Configuración de Cuentas de Depreciación', icono: 'ri-file-transfer-fill', visible: true, evento: () => { setModalupdate({ ...modalupdate, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Parámetros de Activos Fijos">
            <div className="row">
                <div className="col-md-4">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={updateFixedAssetParams}>Actualizar Parámetros de Activos Fijo</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-edit-2-fill" clase="primary" eventClick={verdef}>Definir Consecutivo de Placas</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-file-search-fill" clase="primary" eventClick={getMaxTicketCode}>Consultar Máximo Número de Placas</BasicButton>
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-restart-fill" clase="primary" eventClick={verreiniciar}>Reiniciar Numeración de Placas de Vigencia</BasicButton>
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-file-transfer-fill" clase="primary" eventClick={verup}>Actualizar Configuración de Cuentas de Depreciación</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={fixedAssetline.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">


                            <div className="col-md-12">
                                <label>Nombre de Línea de Activos</label>
                                <input type="text" name="Description" className="form-control" value={fixedAssetline.bean.Description} onChange={fixedAssetline.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={fixedAssetline.bean.Code} onChange={fixedAssetline.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Activo Fijo (D)" jsonCode={fixedAssetline.bean.FixedAssetAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "FixedAssetAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Depreciación (C)" jsonCode={fixedAssetline.bean.DepreciationAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DepreciationAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Gasto (D)" jsonCode={fixedAssetline.bean.ExpensiveAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Vida útil NIIF</label>
                                <input type="text" name="LiveTime" className="form-control" value={fixedAssetline.bean.LiveTime} onChange={fixedAssetline.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Activo en Almacén (D)" jsonCode={fixedAssetline.bean.FixedAssetStoredAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "FixedAssetStoredAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Débito Control (D)" jsonCode={fixedAssetline.bean.DebtControlAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DebtControlAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Crédito Control (C)" jsonCode={fixedAssetline.bean.CreditControlAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "CreditControlAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Revalorización (D)" jsonCode={fixedAssetline.bean.RevaluationAccountantIDDebtStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "RevaluationAccountantIDDebtStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Revalorización (C)" jsonCode={fixedAssetline.bean.RevaluationAccountantIDCreditStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "RevaluationAccountantIDCreditStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Activo Devolutivo (D)" jsonCode={fixedAssetline.bean.AccountantIDReturnableStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "AccountantIDReturnableStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Desvalorización (D)" jsonCode={fixedAssetline.bean.DevaluationAccountantIDDebtStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DevaluationAccountantIDDebtStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Desvalorización (C)" jsonCode={fixedAssetline.bean.DevaluationAccountantIDCreditStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DevaluationAccountantIDCreditStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Activos Menor Cuantía" jsonCode={fixedAssetline.bean.MinFixedAssetAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "MinFixedAssetAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Entrada Almacén Puente Pago" jsonCode={fixedAssetline.bean.InventoryEntryCreditAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "InventoryEntryCreditAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Utilizar Cuenta Puente por Pagar" estado={fixedAssetline.bean.UseInventoryEntryCreditAccountantIDStr} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "UseInventoryEntryCreditAccountantIDStr": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Depreciable" estado={fixedAssetline.bean.Depreciable} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "Depreciable": e }) }}></BasicSwitch>
                            </div>
                            {/* <div className="col-md-6">
                                <BasicSwitch label="Amortizar" estado={fixedAssetline.bean.Depreciable} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "Depreciable": e }) }}></BasicSwitch>
                            </div> */}
                            <div className="col-md-6">
                                <BasicSwitch label="Amortizar" estado={fixedAssetline.bean.Amortize} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "Amortize": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Asegurado" estado={fixedAssetline.bean.InsurancePolicy} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "InsurancePolicy": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta (C) Venta de Activos" jsonCode={fixedAssetline.bean.SelledAccountantIDStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "SelledAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Deterioro(D)" jsonCode={fixedAssetline.bean.DeteriorationAccountantIDDebtStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DeteriorationAccountantIDDebtStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Deterioro (C)" jsonCode={fixedAssetline.bean.DeteriorationAccountantIDCreditStr} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DeteriorationAccountantIDCreditStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectDepreciationUnits idSelector={fixedAssetline.bean.DepreciationUnitsType} onChange={(e) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DepreciationUnitsType": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <label>Vida Útil Fiscal</label>
                                <input type="text" name="FiscalLiveTime" className="form-control" value={fixedAssetline.bean.FiscalLiveTime} onChange={fixedAssetline.handleChange} />
                            </div>
                            <div className="col-md-6">

                                <label>Depreciación Fiscal</label>
                                <input type="text" name="FiscalDepreciable" className="form-control" value={fixedAssetline.bean.FiscalDepreciable} onChange={fixedAssetline.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Usar Cuenta de Amortización" estado={fixedAssetline.bean.UseDepreciationIDForAmortization} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "UseDepreciationIDForAmortizatio": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Cuentas de Orden para Totalmente Depreciado" estado={fixedAssetline.bean.OrderControlForTotalDepreciation} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "OrderControlForTotalDepreciation": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">

                                <label>Concepto Cuentas de Orden</label>
                                <input type="text" name="IDFixedAssetOrderConcept" className="form-control" value={fixedAssetline.bean.IDFixedAssetOrderConcept} onChange={fixedAssetline.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Usar Cuenta Servicio Siempre" estado={fixedAssetline.bean.UseBrandIDAlways} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "UseBrandIDAlways": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Validar Tiempo en Depreciación/Amortización" estado={fixedAssetline.bean.DoTimeRate} eventChange={(e: any) => { fixedAssetline.setBean({ ...fixedAssetline.bean, "DoTimeRate": e }) }}></BasicSwitch>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalcuentas} updateModal={setModalcuentas}>
                        <AuxiliaryBrandList idLine={fixedAssetline.bean.IDLine} />
                    </Modal>
                    <Modal modal={modaldef} updateModal={setModaldef} eventModal={setFixedAssetTicketCodeConsecutive}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Definir Consecutivo de Placas</label>
                                <input type="text" name="Consecutive" className="form-control" value={def.bean.Consecutive} onChange={(e) => { def.setBean({ ...def.bean, "Consecutive": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalupdate} updateModal={setModalupdate} eventModal={updateFixedAssetDepreciationParams}>
                        <div className="row">
                            <div className="col-md-6">
                                <BasicSwitch label="Reemplazar parámetros con los del Grupo de Activos" estado={upfixed.bean.ApplyToAll} eventChange={(e: any) => { upfixed.setBean({ ...upfixed.bean, "ApplyToAll": e }) }}></BasicSwitch>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalup} updateModal={setModalup} eventModal={updateFixedAssetDepreciationParamstwo}>
                        <div className="row">
                            <div className="col-md-6">
                                <BasicSwitch label="Reemplazar parámetros con los del Grupo de Activos" estado={upfixed.bean.ApplyToAll} eventChange={(e: any) => { upfixed.setBean({ ...upfixed.bean, "ApplyToAll": e }) }}></BasicSwitch>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalRe} updateModal={setModalRe} eventModal={restartFixedAssetConsecutivesFrom}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountantYear idSelector={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Consecutivo desde el cual actualizar</label>
                                <input type="text" name="Consecutive" className="form-control" value={form.Consecutive} onChange={(e) => { setForm({ ...form, "Consecutive": parseInt(e.target.value) }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nuevo consecutivo para incio de conteo</label>
                                <input type="text" name="newConsecutive" className="form-control" value={form.newConsecutive} onChange={(e) => { setForm({ ...form, "newConsecutive": parseInt(e.target.value) }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {fixedAssetline.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}
